UIDropdownList.$inject = ["$scope", "$translate"];
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.string.iterator.js";
/* injects from baggage-loader */
require('./ui-dropdownlist.component.html');
import angular from 'angular';
angular.module('AaApp.Opp').component('uiDropdownList', {
  templateUrl: '/app/components/search/ui-dropdownlist.component.html',
  controller: UIDropdownList,
  bindings: {
    fieldName: "<",
    displayNameKey: '<',
    displayNameCssClass: '<',
    values: '<',
    availableGroupNames: '<',
    value: '=',
    multiSelect: '<',
    includeDefaultOption: '<',
    isDisabled: "<",
    triggerInit: "=",
    onChanged: "&"
  }
});

/* @ngInject */
function UIDropdownList($scope, $translate) {
  var $ctrl = this;
  $ctrl.multiSelect = $ctrl.multiSelect ? $ctrl.multiSelect : false;
  $ctrl.$onInit = onInit;
  $ctrl.onSelectionChanged = onSelectionChanged;
  $ctrl.settingsDropdown = {
    dropdownDisable: true,
    template: '{{option.nameText}}',
    smartButtonTextConverter: function smartButtonTextConverter(itemText, option) {
      return option.nameText;
    },
    checkBoxes: true,
    smartButtonMaxItems: 5,
    showCheckAll: true,
    showUncheckAll: true,
    scrollable: true,
    idProperty: 'value'
  };
  $scope.$watch('$ctrl.triggerInit', function (newVal, oldVal, scope) {
    if ($ctrl.triggerInit) {
      $ctrl.triggerInit = false;
      onInit();
    }
  });
  $scope.$watch('$ctrl.values', function (newVal, oldVal, scope) {
    if ($ctrl.values) {
      var _iterator = _createForOfIteratorHelper($ctrl.values),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var val = _step.value;
          if (val.nameKey) {
            val.nameText = $translate.instant(val.nameKey);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  });
  function onInit() {
    if (!$ctrl.displayNameCssClass) $ctrl.displayNameCssClass = "searchDisplayNameWide";
    if (!$ctrl.multiSelect && $ctrl.values.length > 0) {
      $ctrl.value = $ctrl.values[0].value;
      for (var ssav in $ctrl.values) {
        if ($ctrl.values[ssav].selected) {
          $ctrl.value = $ctrl.values[ssav].value;
        }
      }
    }
    if ($ctrl.multiSelect) {
      $ctrl.value = [];
      for (var msav in $ctrl.values) {
        if ($ctrl.values[msav].selected) {
          $ctrl.value.push($ctrl.values[msav]);
        }
      }
    }
  }
  function onSelectionChanged() {
    $ctrl.onChanged({
      selectedValues: $ctrl.value
    });
  }
}